<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <audit-control></audit-control>
      <audit-view></audit-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import AuditControl from "@/modules/audits/auditControl";
import AuditView from "@/modules/audits/auditView";
export default {
  components: {
    AuditControl,
    AuditView
  },
};
</script>

<style>
</style>
